import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';
import { FileDetails } from './addPetVaccination';

export type requestDTO = {
  data: {
    id?:number;
    petId?:number;
    insurance: boolean;
    insuranceName?: string;
    insuranceExpiry?: string;
    insuranceInformation?: string;

  };
};
export type getResponse = {
    id:string;
    petId:number;
    insurance: boolean;
    insuranceName?: string;
    insuranceExpiry?: string;
    insuranceInformation?: string;
    insuranceCopy?: string;
    ownership: string;
    vaccineRecords: string;
};
export type getRequest = {
  data: {
    petId:number;
  };
};

export const addPetInsurance = ({ data }: requestDTO): Promise<getResponse> => {
  return axios.post(`parent/pet-insurance/add`, data);
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof addPetInsurance>;
};

export const useAddPetInsurance = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet insurance added successfully',
      });
    },
    ...config,
    mutationFn: addPetInsurance,
  });
};

export const getPetInsurance = ({ data }: getRequest): Promise<getResponse> => {
  return axios.post(`parent/pet-insurance/get`, data);
};

type UseGetInsuranceOptions = {
  config?: MutationConfig<typeof getPetInsurance>;
};

export const useGetPetInsurance = ({ config }: UseGetInsuranceOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getPetInsurance,
  });
};

export type requestDTOUploadImage = {
  file : FormData
  onlyDocument?: boolean;
};

export const addPetDocuments = ({ file, onlyDocument=false }: requestDTOUploadImage): Promise<FileDetails> => {
  return axios.post(onlyDocument ? `parent/upload-document` : `parent/pet/upload-document`, file);
};

type UseUpdateDocumentOption = {
  config?: MutationConfig<typeof addPetDocuments>;
};

export const useUploadDocument = ({ config }: UseUpdateDocumentOption = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet document uploaded successfully',
      });
    },
    ...config,
    mutationFn: addPetDocuments,
  });
};

export type requestRemove = {
  data: {
    id:string;
    file:string;
    type: string;
  },
  onlyDocument?: boolean;
};
export const removePetDocuments = ({ data, onlyDocument = false }: requestRemove): Promise<boolean> => {
  return axios.post(onlyDocument ? `parent/delete-document` : `parent/pet/delete-document`, onlyDocument ? {fileId: data.id} : data);
};

type UseDeleteDocumentOption = {
  config?: MutationConfig<typeof removePetDocuments>;
};

export const useDeleteDocument = ({ config }: UseDeleteDocumentOption = {}) => {
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Pet document deleted successfully',
      });
    },
    ...config,
    mutationFn: removePetDocuments,
  });
};